import {OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {FormattingService} from '../../formatting/formatting.service';
import {Subscription} from 'rxjs';

export function formatCurrencyValue(value: number | string, formatService: FormattingService, allowDecimal: boolean = true, forceDecimal: boolean = false) {
	let output: string;

	if (typeof value === 'string') {

		// If input value is not even a number then don't format
		// e.g. '-'
		if (isNaN(parseInt(value))) {
			output = value;
		} else {
			output = formatService.currencySymbol + value;
		}
	} else if (typeof value === 'number') {
		output = formatService.formatCost(value, allowDecimal, forceDecimal);
	} else {
		// null or undefined
		output = '-';
	}

	return output;
}

/**
 * Formats a value (string or number) with a currency symbol as provided by FormattingService
 * To force the symbol to update when FormattingService updates, we have to make the pipe impure.
 * However we cache the transformed value so we don't have to recompute every frame.
 */
@Pipe({
    name: 'currencyValue',
    pure: false,
    standalone: false
})
export class CurrencyValuePipe implements PipeTransform, OnDestroy {

	private lastValue: number | string;
	private isDirty: boolean;
	private cachedOutput: string;
	private changes$: Subscription;

	constructor(private formatService: FormattingService) {
		this.changes$ = formatService.onFormattingChanged.subscribe(() => {
			this.isDirty = true;
		});
	}

	transform(value: number | string, allowDecimal: boolean = true, forceDecimal: boolean = false): string {
		if (this.lastValue === value && !this.isDirty) {
			return this.cachedOutput;
		}

		this.lastValue = value;
		this.isDirty = false;
		this.cachedOutput = formatCurrencyValue(value, this.formatService, allowDecimal, forceDecimal);
		return this.cachedOutput;
	}

	ngOnDestroy() {
		if (this.changes$) {
			this.changes$.unsubscribe();
		}
	}
}
